import React from "react";
import styles from "./menuIcon.scss";

const MenuIcon = ({ onClick }) => (
  <span tabIndex={0} role="button" onClick={onClick} className={styles.menuIcon} aria-label="Kategorija">
    <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 0C25 1.16196 25 1.81556 25 1.94006C10 1.94006 1.67 1.94006 0 1.94006C0 0.778098 0 0.124496 0 0C15 0 23.33 0 25 0Z" fill="currentColor" />
      <path d="M25 8.02997C25 9.19193 25 9.84553 25 9.97003C10 9.97003 1.67 9.97003 0 9.97003C0 8.80807 0 8.15447 0 8.02997C15 8.02997 23.33 8.02997 25 8.02997Z" fill="currentColor" />
      <path d="M25 16.0599C25 17.2219 25 17.8755 25 18C10 18 1.67 18 0 18C0 16.838 0 16.1844 0 16.0599C15 16.0599 23.33 16.0599 25 16.0599Z" fill="currentColor" />
    </svg>
  </span>
);

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/components/Header/MobileHeader/MenuIcon/index.tsx